import { createFileRoute } from '@tanstack/react-router';
import { toolsStaticData } from '../tools';

export const Route = createFileRoute('/_private-routes/tools/video-comp-ai')({
  component: RouteComponent,
  staticData: toolsStaticData
});

function RouteComponent() {
  return <div>Hello "/_private-routes/tools/video-comp-ai"!</div>;
}
